export const LIKE_REACTION = '👍'

export const DELTA_TIME_SECONDS = 900

export const CHAT_LOADING_LIMIT = 25

export const EMOJI_POPUP_HEIGHT = 100

export const PROFILE_POPUP_HEIGHT = 145
